// ======================================================================
// File Name       : EnterpriseReasonForCancelContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import * as enterpriseActions from '../../actions/EnterpriseAction';
import * as modalActions from '../../actions/ModalAction';
import EnterprisePreCancelForm from '../../components/enterprise/EnterprisePreCancelForm';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { ENTERPRISE_PRECANCEL, ENTERPRISE_REASON_FOR_CANCEL } from '../../constants/ModalIds';
import EnterpriseReasonForCancelForm from '../../components/enterprise/EnterpriseReasonForCancelForm';
import { CANCEL_REASON } from '../../constants/EnterpriseConstants';

class EnterpriseReasonForCancelContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
      checkbox5: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
  }

  getModalOptions() {
    return {
      title: '解約の理由をお聞かせください',
      footerBtns: [
        { name: 'プラン解約をやめる', onClick: this.props.hideModal },
        {
          name: '解約時の注意事項確認へ進む',
          onClick: this.handleSubmit,
          className: 'btn-enterpriseCancel',
        },
      ],
    };
  }

  handleSubmit() {
    const { dispatch, authedUser: { enterpriseCd }, enterpriseReasonForCancelForm } = this.props;

    let otherReason;
    if (enterpriseReasonForCancelForm && enterpriseReasonForCancelForm.values) {
      otherReason = enterpriseReasonForCancelForm.values.otherReason;
    }

    const params = {
      enterpriseCd,
      ssCancelReason1: this.getCancelReasonString(),
      ssCancelReason2: otherReason,
    };

    dispatch(enterpriseActions.saveEnterpriseReason(params));
    dispatch(modalActions.openModal(ENTERPRISE_PRECANCEL));
  }

  getCancelReasonString() {
    let cancelReason = '';
    const { checkbox1, checkbox2, checkbox3, checkbox4, checkbox5 } = this.state;

    if (checkbox1) {
      cancelReason = cancelReason.concat(CANCEL_REASON.REASON_1);
    }

    if (checkbox2) {
      cancelReason = cancelReason.concat('/').concat(CANCEL_REASON.REASON_2);
    }

    if (checkbox3) {
      cancelReason = cancelReason.concat('/').concat(CANCEL_REASON.REASON_3);
    }

    if (checkbox4) {
      cancelReason = cancelReason.concat('/').concat(CANCEL_REASON.REASON_4);
    }

    if (checkbox5) {
      cancelReason = cancelReason.concat('/').concat(CANCEL_REASON.REASON_5);
    }

    // remove front trailing if necessary
    cancelReason = cancelReason.startsWith('/') ? cancelReason.slice(1, cancelReason.length) : cancelReason;
    return cancelReason;
  }

  onChangeCheckbox(event) {
    const { name, checked } = event.target;
    this.setState({
      ...{ [name]: checked },
    });
  }

  render() {
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.props.hideModal}>
        <EnterpriseReasonForCancelForm
          onChangeCheckbox={this.onChangeCheckbox}
        />
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { authedUser } = state.authed;
  const { enterpriseReasonForCancelForm } = state.form;
  return {
    authedUser,
    ...{ enterpriseReasonForCancelForm },
  };
};

export default connect(mapStateToProps)(EnterpriseReasonForCancelContainer);
